import * as types from "../types/foodPageUiState"

const initialState = {
  sidebar: false,
  searchBar: false
}

const foodPageUiState = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_FOOD_SIDEBAR:
      return {
        ...state,
        sidebar: true
      }
    case types.HIDE_FOOD_SIDEBAR:
      return {
        ...state,
        sidebar: false
      }
    case types.SHOW_FOOD_SEARCH_BAR:
      return {
        ...state,
        searchBar: true
      }
    case types.HIDE_FOOD_SEARCH_BAR:
      return {
        ...state,
        searchBar: false
      }
    case types.TOGGLE_FOOD_SEARCH_BAR:
      return {
        ...state,
        searchBar: !state.searchBar
      }
    case types.TOGGLE_FOOD_SIDEBAR:
      return {
        ...state,
        sidebar: !state.sidebar
      }
    default:
      return state
  }
}

export default foodPageUiState